<template>
    <VDBaseTemplate>
      <br><br><br>
      <div class="w-100 h-100">
        <b-modal
          id="api-err-modal"
          v-model="apiErrModalShow"
          centered
          scrollable
          hide-footer
          hide-header-close
          no-close-on-backdrop
          no-close-on-esc
          title="Dataset Fetch Error"
          :header-bg-variant="'warning'"
          :header-text-variant="'light'">
          <span v-html="err_msg"></span>
          <b-button class="mt-3 button-link" :to="{name: 'vecdyn-datasets'}" block>Return to dataset list</b-button>
        </b-modal>
  
        <b-container fluid>
          <div class="title-area">
            <center>
                <br><br>
                <img
                    src="@/assets/images/logos/vecdyn_logo.svg"
                    class="mr-2"
                    width=45px
                />
                <h2>VecDyn Column Definitions</h2>
            </center>
          </div>
          <div style="color: black; text-align: left; padding: 50px;">
            <b-table
              ref="table"
              striped 
              responsive
              bordered
              head-variant="light"
              style="overflow-x:auto"
              :items="data"
              :fields="fields"
              :busy.sync="loading"
            >
            <!-- A custom formatted header cell to allow styling -->
            <template v-slot:head()="field">
                <span style="font-size: small; white-space: nowrap;">
                    {{ field.label }}
                </span>
            </template>
            </b-table>
          </div>
          <b-row>
            <b-col>
              <div style="float: right;" class="ml-1">
                <b-button 
                  class="button-link mb-2" 
                  :to="{name: 'vecdyn-datasets'}" 
                  variant="primary" 
                  size="sm" 
                  block
                >
                  Return to VecDyn Datasets Explorer Page
                </b-button>
              </div>
              <div style="float: right;" class="ml-1">
                <b-button 
                  class="button-link mb-2" 
                  :to="{name: 'submit-vecdyn'}" 
                  variant="primary" 
                  size="sm" 
                  block
                  v-if="admin_authorized"
                >
                  Return to Upload Page
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
  
      </div>
    </VDBaseTemplate>
  </template>
  <script>
  import { mapState } from "vuex";
  import * as _ from "lodash";
  import { HTTP } from "@/utilities/http-common";
  import HandleErrors from "@/utilities/handle-errors";
  import VDBaseTemplate from "@/layouts/VDBaseTemplate.vue";
  export default {
    name: "vecdyn-columndefs",
    mixins: [VDBaseTemplate],
    components: {
      VDBaseTemplate,
    },
    computed: {
      ...mapState("user", ["user", "myGroups"]),
      admin_authorized : function() {
        const that = this;
        // store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])
        let groups = ['admin', 'uploader', 'collaborator'];
        return Boolean((_.intersection(that.myGroups, groups)).length);
      },
    },
    data(){
      return{
          data: [],
          fields: [
            { key: 'field_name', 'tdClass': 'vt-table-cell column-width-16p' },
            { key: 'definition', 'tdClass': 'vt-table-cell column-width-20p' },
            { key: 'notes', 'tdClass': 'vt-table-cell column-width-20p' },
            { key: 'is_required', 'tdClass': 'vt-table-cell column-width-10p' },
            { key: 'data_format', 'tdClass': 'vt-table-cell column-width-10p'},
            { key: 'restrictions', 'tdClass': 'vt-table-cell' },
          ],
          loading: false,
          err_msg: '',
          apiErrModalShow: false,
      };
    },
    created() {
      this.getDataset();
    },
    methods: {
      getDataset() {
        const that = this;
        return HTTP.get(`/api/vecdyn-columns`)
        .then(response => {
          that.data = response.data;
  
          that.convertRestrictionsArrayToString(that.data);
  
        })
        .catch(error => {
          that.err_msg = HandleErrors.HandleErrors(error);
          that.apiErrModalShow = true;
        });
      },
      convertRestrictionsArrayToString(data) {
        data.forEach(function(obj) {
          let restriction_list = []
          obj.restrictions.forEach(function(restriction) {
            restriction_list.push(restriction.definition)
            
          })
          obj.restrictions = restriction_list.join(", ");
        })
      },
    }
  };
  </script>
  <style>
  .column-width-10p {
    width: 10%;
    min-width: 110px;
  }
  
  .column-width-15p {
    width: 15%;
    min-width: 200px;
  }
  
  .column-width-20p {
    width: 20%;
    min-width: 250px;
  }
  
  .title-area h2, h5 {
    display: inline;
    vertical-align:middle
  }
  
  </style>